import { BuyCloudPostOrderProvisioningPageTemplate } from '../../../../templates/buy/cloud/post-order-provisioning/src/buy-cloud-post-order-provisioning-page.template';

export const BuyCloudPostOrderProvisioningPage = () => (
	<BuyCloudPostOrderProvisioningPageTemplate />
);
